// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shadow-custom {
    box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
  }
  
  .custom-right-border {
    position: relative;
  }
  
  .custom-right-border::after {
    content: '';
    position: absolute;
    top: 32px; /* Adjust this value for padding-top */
    bottom: 32px; /* Adjust this value for padding-bottom */
    right: 0;
    width: 1px;
    background-color: #D1D5DB; /* Tailwind's gray-300 */
  }

/* Password toggle button visibility fix */

.login-page .MuiInputAdornment-positionEnd {
  visibility: visible !important;
  display: flex !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  width: auto !important;
  height: auto !important;
  position: relative !important;
}

.login-page .MuiInputAdornment-root button,
.login-page .MuiIconButton-root,
.login-page .MuiIconButton-edgeEnd,
.login-page .MuiButtonBase-root {
  visibility: visible !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  color: rgba(0, 0, 0, 0.54) !important;
}

.login-page .MuiIconButton-root:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.login-page .MuiInputAdornment-root svg,
.login-page .MuiSvgIcon-root {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  fill: currentColor !important;
}

/* Ensure button is in front */
.login-page .MuiInputAdornment-root {
  z-index: 1 !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/login/Login.css"],"names":[],"mappings":"AAAA;IACI,2CAA2C;EAC7C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS,EAAE,sCAAsC;IACjD,YAAY,EAAE,yCAAyC;IACvD,QAAQ;IACR,UAAU;IACV,yBAAyB,EAAE,wBAAwB;EACrD;;AAEF,0CAA0C;;AAE1C;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,qBAAqB;EACrB,+BAA+B;EAC/B,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;;;EAIE,8BAA8B;EAC9B,qBAAqB;EACrB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;EAEE,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;AACvB","sourcesContent":[".shadow-custom {\n    box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);\n  }\n  \n  .custom-right-border {\n    position: relative;\n  }\n  \n  .custom-right-border::after {\n    content: '';\n    position: absolute;\n    top: 32px; /* Adjust this value for padding-top */\n    bottom: 32px; /* Adjust this value for padding-bottom */\n    right: 0;\n    width: 1px;\n    background-color: #D1D5DB; /* Tailwind's gray-300 */\n  }\n\n/* Password toggle button visibility fix */\n\n.login-page .MuiInputAdornment-positionEnd {\n  visibility: visible !important;\n  display: flex !important;\n  opacity: 1 !important;\n  pointer-events: auto !important;\n  width: auto !important;\n  height: auto !important;\n  position: relative !important;\n}\n\n.login-page .MuiInputAdornment-root button,\n.login-page .MuiIconButton-root,\n.login-page .MuiIconButton-edgeEnd,\n.login-page .MuiButtonBase-root {\n  visibility: visible !important;\n  opacity: 1 !important;\n  pointer-events: auto !important;\n  color: rgba(0, 0, 0, 0.54) !important;\n}\n\n.login-page .MuiIconButton-root:hover {\n  background-color: rgba(0, 0, 0, 0.04) !important;\n}\n\n.login-page .MuiInputAdornment-root svg,\n.login-page .MuiSvgIcon-root {\n  display: block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  fill: currentColor !important;\n}\n\n/* Ensure button is in front */\n.login-page .MuiInputAdornment-root {\n  z-index: 1 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
